export default "__VITE_ASSET__fKos$W$y__"